<template>
  <div class="home">
    <Login />
  </div>
</template>

<script>
// @ is an alias to /src
import Login from '@/views/Login.vue'

export default {
  name: 'Home',
  components: {
    Login
  }
}
</script>
<style scoped>
.home {
  margin: 0;
  padding: 0;
  width: 100%;
}
</style>
